export const fuelingDiscovery = `
# Fueling Discovery
</br></br>
<div id="video"> https://www.youtube.com/embed/9DU6DZTJ-g0?si=GUW5yoK2MbVc4eEy </div>
</br></br><div style="margin:auto; text-align:center;">
<p>Kwik Fill Country contains amazing attractions and destinations, of which some you might not even be aware.</p>
</br></br>
<a href="https://www.fuelingdiscovery.com" id="button" target="_blank">Learn More</a><a href="/win" id="button" target="_blank">Enter Giveaway</a>
</div></br></br>
</br></br>`